import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserAccountEditRoutingModule } from './user-account-edit-routing.module';
import { UserAccountEditComponent } from './pages/user-account-edit/user-account-edit.component';
import { HeaderUserAccountEditComponent } from './components/header-user-account-edit/header-user-account-edit.component';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SkeletonUserAccountEditComponent } from './components/skeleton-user-account-edit/skeleton-user-account-edit.component';
import { SkeletonFooterUserAccountEditComponent } from './components/skeleton-footer-user-account-edit/skeleton-footer-user-account-edit.component';

@NgModule({
    declarations: [
        UserAccountEditComponent,
        HeaderUserAccountEditComponent,
        SkeletonUserAccountEditComponent,
        SkeletonFooterUserAccountEditComponent,
    ],
    imports: [
        CommonModule,
        UserAccountEditRoutingModule,
        IonicModule,
        SharedModule,
        ReactiveFormsModule,
    ],
})
export class UserAccountEditModule {}
